<nz-spin [nzSpinning]="loading">
    <div [ngClass]="fullscreen ? 'fullscreen-page' : ''">
        <div class="detail-header">
            <div *ngIf="detail && detail.parentTaskId; else emptyHeader" class="task-code">
                <nz-breadcrumb>
                    <nz-breadcrumb-item style="cursor: pointer; " *ngIf="fullscreen">
                        <span nz-icon [nzType]="'svg:kanban'" nzTheme="outline" class="task-icon"></span><a
                            [routerLink]="['/kanban-board/'+projectKey]">{{projectKey}}</a>
                    </nz-breadcrumb-item>
                    <nz-breadcrumb-item style="cursor: pointer; ">
                        <!-- <img [src]="'assets/svg/' + detail.configIcon + '.svg'" class="task-icon"> -->
                        <a (click)="navigateToParent()">{{detail.parentTaskKey}}</a>
                    </nz-breadcrumb-item>
                    <nz-breadcrumb-item>
                        <img [src]="'assets/svg/' + detail.configIcon + '.svg'" class="task-icon">
                        <a>{{detail.taskKey}}</a>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
            </div>
            <ng-template #emptyHeader>
                <div class="task-code">
                    <nz-breadcrumb *ngIf="detail">
                        <nz-breadcrumb-item style="cursor: pointer; " *ngIf="fullscreen">
                            <span nz-icon [nzType]="'svg:kanban'" nzTheme="outline" class="task-icon"></span><a
                                [routerLink]="['/kanban-board/'+ projectKey]">{{projectKey}}</a></nz-breadcrumb-item>
                        <nz-breadcrumb-item>
                            <span nz-icon [nzType]="'svg:'+ (detail.configIcon|| 'dtask')" nzTheme="outline"
                                class="task-icon"></span>
                            {{ detail.taskKey }}
                        </nz-breadcrumb-item>
                    </nz-breadcrumb>
                </div>
            </ng-template>
            <div class="right-action">
                <div class="action-item"  (click)="copyLink()">
                    <span nz-icon nzType="link" class="action-icon"></span>
                </div>

                <div *ngIf="!fullscreen" class="action-item" (click)="switchFullscreen()">
                    <span nz-icon nzType="fullscreen" nzTheme="outline" class="action-icon"></span>
                </div>

                <!-- <div *ngIf="detail && detail.taskId" class="action-item">
                    <span nz-icon nzType="eye" nzTheme="outline" class="action-icon"></span>
                    {{ taskComments.length }}
                </div> -->

                <!-- <div class="action-item">
                    <span nz-icon nzType="svg:link-outline" class="action-icon"></span>
                </div> -->
                <nz-dropdown-menu #moreAction="nzDropdownMenu">
                    <ul nz-menu nzSelectable *appPermission="['Task Delete']">
                        <li nz-menu-item (click)="deleteTask()" nzDanger>Delete</li>
                        <!-- <li nz-menu-item >Clone</li> -->
                    </ul>
                </nz-dropdown-menu>

                <div class="action-item" nz-dropdown [nzDropdownMenu]="moreAction">
                    <span nz-icon nzType="svg:more" class="action-icon"></span>
                </div>

                <div class="action-item" (click)="close()" *ngIf="!fullscreen">
                    <span nz-icon nzType="close" nzTheme="outline" class="action-icon"></span>
                </div>
            </div>
        </div>
        <div class="content-container">
            <div class="left-container" cdkScrollable (scroll)="onContainerScroll($event)">
                <ng-container *ngFor="let fieldItem of descriptionFields; let idx = index">
                    <div class="task-info">
                        <ng-container *ngIf="fieldItem.fieldKey == 'taskName'">
                            <h1 class="task-name">
                                <app-z-input [initialValue]="detail.taskName" [required]="true" [inactiveUsers]="hasInactiveUsers"
                                    (valueSaved)="changeTaskName($event)"></app-z-input>
                            </h1>
                            <div class="task-action">
                                <app-file-upload
                                    [showUploadList]="false"
                                    [render]="uploadTemplate"
                                    [batchUpload]="true"
                                    [inactiveUsers]="hasInactiveUsers"
                                    (uploadEvent)="saveAttach($event)"
                                ></app-file-upload>
                                <ng-template #uploadTemplate>
                                    <button nz-button class="action-button" [nzLoading]="uploadLoading">
                                        <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
                                        Attach
                                    </button>
                                </ng-template>

                                <button *ngIf="!isSubTask" nz-button class="action-button" (click)="addSubTask()">
                                    <span nz-icon nzType="sisternode" nzTheme="outline"></span>
                                    Create subtask
                                </button>

                                <button *ngIf="!isSubTask" nz-button nz-dropdown class="action-button"
                                    (click)="linkTask()">
                                    <span nz-icon nzType="link" nzTheme="outline"></span>
                                    Link Task
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="fieldItem.fieldKey == 'description'">
                            <h2 class="sub-title">Description</h2>
                            <div class="desc-content">
                                <app-input-content
                                    #descCom
                                    [saveLoading]="descLoading"
                                    [content]="detail.description"
                                    [editorId]="'task_description'"
                                    [clickToEdit]="true"
                                    [members]="projectMembers"
                                    [inactiveUsers]="hasInactiveUsers"
                                    (editSuccess)="saveDesc($event)"
                                ></app-input-content>
                            </div>
                        </ng-container>
                        <app-task-attachments
                        *ngIf="fieldItem.fieldKey == 'attachment' && showAttachList"
                                #fileList
                                [taskDetail]="detail"
                                [field]="defaultAttachmentField"
                                [templateAllFields]="templateAllFields"
                                [batchUpload]="true"
                                [inactiveUsers]="hasInactiveUsers"
                                (uploadEvent)="saveAttach($event)"
                                (updateAttachment)="updateTask($event)"
                        ></app-task-attachments>
                    </div>

                    <div *ngIf="!isSubTask && fieldItem.fieldKey == 'linkedTaskIds' && detail.linkedTasks.length > 0" class="dependent-task">
                        <h2 class="sub-title">Linked tasks</h2>
                        <div class="task-rows">
                            <app-link-task-item *ngFor="let item of detail.linkedTasks; let index = i" [item]="item"
                                [swimLaneList]="swimLaneList" [inactiveUsers]="hasInactiveUsers"
                                (remove)="removeLinkTask(index, item)"  (closeEvent)="onStatusChange($event)"></app-link-task-item>
                        </div>
                    </div>

                    <div class="dependent-task" *ngIf="fieldItem.fieldKey == 'parentTaskId' && subTask.length > 0">
                        <h2 class="sub-title">Sub tasks</h2>
                        <div class="task-rows" *ngIf="subTask && subTask.length">
                            <app-sub-task-item *ngFor="let item of subTask" [item]="item" [swimLaneList]="swimLaneList" [inactiveUsers]="hasInactiveUsers"
                                (remove)="removeSubTask(item)"></app-sub-task-item>
                        </div>
                    </div>

                    <div class="dependent-task" *ngIf="!fieldItem.fieldKey">
                        <h2 class="sub-title" *ngIf="!hasTimeCategories.includes(fieldItem.categoryName)">{{ fieldItem.fieldName }}</h2>
                        <div class="task-rows">
                            <app-field-item
                                    [taskInfo]="detail"
                                    [accountList]="accountList"
                                    [templateAllFields]="templateAllFields"
                                    [field]="fieldItem"
                                    [projectMembers]="projectMembers"
                                    (saveField)="saveFieldRefresh($event)"
                                    (updateInactiveUsers)="updateInactiveUsers($event)"
                            >
                            </app-field-item>
                        </div>
                    </div>
                </ng-container>

                <div class="activity-container">
                    <h2 class="sub-title">Activity</h2>
                    <div class="panel-header">
                        <div class="activity-menu">
                            <div>Show:</div>
                            <div *ngFor="let activityType of activityTypeOptions" class="activity-type"
                                [ngClass]="activityType === currentActivityType ? 'activity-type-active' : ''"
                                (click)="changeActivityType(activityType)">
                                {{ activityType }}
                            </div>
                        </div>

                        <div class="activity-sort" (click)="changeActivitySort()">
                            {{ activitySort === 'desc' ? 'Newest first' : 'Oldest first' }}
                            <span *ngIf="activitySort === 'desc'" nz-icon nzType="svg:sort-descending"></span>
                            <span *ngIf="activitySort !== 'desc'" nz-icon nzType="svg:sort-arrow-up"></span>
                        </div>
                    </div>

                    <nz-spin [nzSpinning]="activityLoading">
                        <ng-container *ngIf="currentActivityType === 'All' || currentActivityType === 'Comments'">
                            <app-activity-comment [taskId]="taskId" [accountList]="accountList" [isAdd]="true" [isSubtask]="isSubTask" [userInfo]="userInfo" [projectMembers]="projectMembers"
                                                  [inactiveUsers]="hasInactiveUsers"
                                                  (saveComment)="saveComment($event)"></app-activity-comment>

                            <div *ngFor="let item of taskComments; let commentIndex = index">
                                <app-activity-comment [item]="item"  [accountList]="accountList" [isSubtask]="isSubTask" [userInfo]="userInfo" [projectMembers]="projectMembers"
                                                      [inactiveUsers]="hasInactiveUsers"
                                                      (saveComment)="saveComment($event, commentIndex)" (deleteComment)="deleteComment(commentIndex)"></app-activity-comment>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="currentActivityType === 'All' || currentActivityType === 'History'">
                            <div *ngFor="let item of taskHistories">
                                <app-activity-history [item]="item" [pluralCategories]="pluralCategories" [accountList]="accountList"></app-activity-history>
                            </div>
                            <div class="loadmore" style="text-align: center; margin-top: 8px" nz-list-load-more *ngIf="historyTotal > taskHistories.length">
                                <button nz-button [nzLoading]="activityLoading" (click)="onLoadMore()">Loading More</button>
                            </div>
                        </ng-container>
                    </nz-spin>
                </div>
            </div>

            <div class="right-container" cdkScrollable (scroll)="onContainerScroll($event)">
                <app-task-fields #taskFieldsCom [taskInfo]="detail" [projectMembers]="projectMembers" [defaultFields]="defaultFields"
                    [moreFields]="moreFields" [accountList]="accountList" [swimLaneList]="swimLaneList"
                    [inactiveUsers]="hasInactiveUsers"
                    (saveField)="saveFieldRefresh($event)"
                    (taskInfoChange)="onTaskInfoChange($event)"
                    [templateAllFields]="templateAllFields"></app-task-fields>
            </div>
        </div>
    </div>
</nz-spin>


<app-task-create #addTask [projectId]="detail.projectId" [taskId]="taskId"
    (success)="getTaskDetail()"></app-task-create>

<app-add-task-link [projectId]="detail.projectId" [taskDetail]="detail" #addTaskLink
    (submitSuccess)="getTaskDetail()"></app-add-task-link>
